<template>
  <div class="m-list">
    <div class="width-a">
      <h1 class="title">我的收藏</h1>
      <div class="content">
        <div class="toolsb">
          <el-input class="mb-input" placeholder="请输入资源名称" v-model="keyword"></el-input>
          <el-button type="primary" @click="toQuery">搜索</el-button>
          <el-button type="primary" @click="resetQuery">重置</el-button>
        </div>
        <ul class="ors">
          <template v-for="(item, index) in tableData">
            <li class="c-item" :key="item.resourceId" @click="detailTap(index)">
              <div class="ci-img">
                <img :src="item.imgUrl | fileFilter" alt="">
              </div>
              <h2 class="ci-title m-text-ellipsis">{{item.resourceName}}</h2>
              <p class="ci-desc m-text-ellipsis-c">{{item.introduce}}</p>
              <div class="ci-info">
                <span>{{item.clickCount}} 人观看</span>
              </div>
            </li>
          </template>
        </ul>
      </div>
      <el-pagination class="ma-pagination" :current-page="curPage" layout="total, prev, pager, next" :total="total" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </div>
</template>
<script>
import HttpConnection from "@/utils/HttpConnection";
import CommonFilters from "@/mixins/CommonFilters";
export default {
  name: "MyCollection",
  mixins: [CommonFilters],
  data () {
    return {
      keyword: "",// 搜索内容
      tableData: [],
      curPage: 1, // 当前页
      total: 0, // 总条数
    }
  },
  mounted () {
    this.toQuery()
  },
  // 监听
  computed: {
    userInfo () {
      return this.$store.state.user.userInfo;
    },
  },
  methods: {
    // 搜索
    toQuery () {
      let that = this;
      that.HttpConnection.get("/openresource/list/owner", {
        userId: that.userInfo.userId,
        keyword: that.keyword,
        pageNum: that.curPage,
        pageSize: 8,
      }).then(res => {
        if (res.code === 200) {
          that.tableData = res.rows;
          that.total = res.total;
          // console.log(res);
        }
      }).catch(err => {
        console.log(err);
      })
    },
    // 重置
    resetQuery () {
      this.keyword = "",
        this.toQuery();
    },
    // 切换分页
    handleCurrentChange (val) {
      this.curPage = val
      this.toQuery();
    }
  },
}
</script>
<style lang="scss" scoped>
.m-list {
  background-image: url("../assets/bga01.png");
  background-repeat: no-repeat;
}

.title {
  font-size: 36px;
  font-weight: normal;
  color: #ffffff;
  text-align: center;
  padding: 60px 0px 40px 0px;
}

.type {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;

  .type-a {
    width: 140px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    background-color: #395bcd;
    color: #ffffff;
    font-size: 16px;
    margin: 0px 16px;
    cursor: pointer;
  }

  .type-b {
    width: 140px;
    height: 46px;
    text-align: center;
    line-height: 46px;
    background-color: #253b85;
    color: #ffffff;
    font-size: 16px;
    margin: 0px 16px;
    cursor: pointer;
  }
}

.content {
  padding: 60px 44px 0px 44px;
  margin-top: 60px;
  background-color: #ffffff;
}

.ors {
  display: grid;
  grid-row-gap: 20px;
  grid-column-gap: 35px;
  grid-template-columns: repeat(3, 334px);
}

.c-item {
  width: 326px;
  height: 336px;
  border: solid 1px #e3e4e5;
  padding: 20px;
  margin: 10px;
  cursor: pointer;
}

.ci-img {
  width: 286px;
  height: 176px;

  img {
    width: auto;
    height: auto;
    max-width: 100%;
    max-height: 100%;
    margin: auto;
  }
}

.ci-title {
  font-size: 18px;
  color: #333333;
  font-weight: normal;
  padding: 0px 6px;
  margin: 15px 0px;
}

.ci-desc {
  font-size: 14px;
  color: #999999;
  padding: 0px 6px;
  height: 20px;
  margin: 10px 0;
}

.ci-info {
  color: #999999;
  font-size: 14px;
  border-top: 1px solid #e8e9eb;
  padding: 10px 6px 0px 6px;
}
</style>